import type { InitiatePaymentInput, Payment } from '@bcl/shared';
import { api } from '@/lib/api';

export type InitiatePaymentResponse =
  | { method: 'carte'; payment: Payment; redirectUrl: string }
  | {
      method: 'virement';
      payment: Payment;
      bank: { iban: string; bic: string; beneficiary: string };
      reference: string;
    };

export async function initiatePayment(
  input: InitiatePaymentInput,
): Promise<InitiatePaymentResponse> {
  const { data } = await api.post<InitiatePaymentResponse>(
    '/payments/initiate',
    input,
  );
  return data;
}

export async function listPaymentsForProject(
  projectId: string,
): Promise<Payment[]> {
  const { data } = await api.get<Payment[]>(`/payments/by-project/${projectId}`);
  return data;
}

export async function syncPaymentFromFam(
  paymentId: string,
): Promise<{ payment: Payment; updated: boolean }> {
  const { data } = await api.post<{ payment: Payment; updated: boolean }>(
    `/payments/${paymentId}/sync-from-fam`,
    {},
  );
  return data;
}
